'use strict';
import * as $j_app$002eapi$002e$002dDrug$002dRequest$002dData from "./app.api.-Drug-Request-Data.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$40(evaluator$27) {
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$40__f_evaluator$7 = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$40__f_evaluator$7 = evaluator$27;
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$40 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$40 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$40.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$40.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$40;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$40() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$40 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$40 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$40.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$40.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$40.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$40.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_DrugRequestsAcceptedListItem$$anon$40__f_evaluator$7.apply__O();
  return ((v instanceof $j_app$002eapi$002e$002dDrug$002dRequest$002dData.$c_Lapp_api_DrugRequestData) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$40.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$40 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$40, "app.api.DrugRequestsAcceptedListItem$$anon$40", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$40: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$40 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$40 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$40.js.map
